import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect } from "react";
import { extendedSystemStylesProps } from "@mixins";
import { debounce } from "utils/debounce";
import { Flex } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["color", "space", "layout", "flexbox", "position"];
export var ErrorBanner = function ErrorBanner(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    content = _useState4[0],
    setContent = _useState4[1];
  useEffect(function () {
    var closeTimeout;
    var closeEvent = debounce(function () {
      return window.dispatchEvent(new CustomEvent("closeErrorNotification"));
    }, [5000]);
    var open = function open(e) {
      closeTimeout = setTimeout(function () {
        closeEvent();
      }, [9000]);
      setShow(true);
      setContent(e.detail);
    };
    var close = function close() {
      clearTimeout(closeTimeout);
      setShow(false);
      setContent(null);
    };
    window.addEventListener("showErrorNotification", open);
    window.addEventListener("closeErrorNotification", close);
    return function () {
      var _window, _window2;
      (_window = window) === null || _window === void 0 ? void 0 : _window.removeEventListener("closeErrorNotification", close);
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.removeEventListener("showErrorNotification", open);
      clearTimeout(closeTimeout);
    };
  }, []);
  return show && /*#__PURE__*/_jsx(Flex.Row, _objectSpread(_objectSpread({
    zIndex: "100",
    position: "sticky",
    top: "0"
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: content
  }));
};